import StarRoundedIcon from '@mui/icons-material/StarRounded';
const Star = () => {
	return <StarRoundedIcon sx={{ color: "#fcd53f", fontSize: "1.4em", verticalAlign:"-.5rem"}} />;
}
export default Star;